import React from "react";
import "./Sobre.css";
import IMGJOTAV from "../../assets/images/jotav.JPG";
import IMGANAC from "../../assets/images/anac.png";

const Sobre = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="sobre-container  p-5" id="sobre">
      <div className="container  d-flex justify-content-center">
        <div className="container-titulo-sobre">
          <h2 className="text-center text-white titulo-sobre">
            Quem é JotaV ?
          </h2>
        </div>
      </div>
      <div className={`container p-5 d-flex justify-content-center`}>
        <div className="row">
          <div className="col-lg-4"></div>
          <div className="col-lg-4 col-12 p-3 mt-5 container-sobre">
            <img
              className="sobre-image"
              src={IMGJOTAV}
              style={{
                marginLeft: !matchResult ? "35px" : "-3px",
              }}
            />
            <h2 className="bg-white text-center">Piloto de Drones</h2>
            <p className="text-white">
              Programador e Estrategista digital a mais de 5 anos, decidi unir
              os conhecimentos para aumentar a qualidade de vídeo para os
              clientes e melhorar o alcance nas plataformas para maior
              lucratividade.
              <br /> Descobri o drone e a Edição de Vídeo em um desejo de mudar
              de área, me especializei na criação de conteúdos promocionais,
              atuando na pós produção, edição e finalização, com o objetivo
              aumentar o enganjamento nas redes mais utilizadas no mercado.
            </p>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>
      <div
        className={`container p-5  d-flex justify-content-center container-cadastro-sobre`}
      >
        <div className="col-lg-4"></div>

        <div
          className="container-titulo-sobre-cadastro col-lg-6"
          style={{
            marginLeft: !matchResult ? "" : "0",
          }}
        >
          <h2 className="text-center titulo-sobre-cadastro">
            Piloto Cadastrado Equipamentos Homologados
          </h2>
          <p className="ml-3">
            Nossas aeronaves são devidamente cadastradas e homologadas pelos
            órgãos regulamentadores. Todos os voos contam com licenças e
            autorizações especiais para serem realizados nos mais diversos
            locais, que não sejam em áreas com restrições ou em condições
            adversas.
          </p>
          <img
            className="ml-lg-5"
            src={IMGANAC}
            style={{
              width: !matchResult ? "" : "340px",
            }}
          />
        </div>
        <div className="col-lg-3"></div>
      </div>
    </div>
  );
};

export default Sobre;
